import { Button, Menu, MenuItem } from '@mui/material';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import DownloadButtonIcon from '../../../assets/svg/downloadIconGray.svg';
import { generateReportDocx } from '../../../assets/utils/docx/FinalReportDocx';
import { generateFinalReportPDF } from '../../../assets/utils/pdfs/FinalReportPDF';
import { ModifiedFinalReportDocument } from '../../../interfaces/ModifiedFinalReportDocument';
import reportService from '../../../services/reportService';
import { RootState } from '../../../utils/store';

interface DownloadReportButtonProps {
  pdfData: ModifiedFinalReportDocument;
}

const DownloadFinalReportButton = ({ pdfData }: DownloadReportButtonProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const roles = useSelector((state: RootState) => state.userRoles);
  const openMenu = Boolean(anchorEl);
  const handleClickDownloadButton = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseDownloadMenu = () => {
    setAnchorEl(null);
  };
  const generateFinalReport = async () => {
    const reportPDF = await generateFinalReportPDF(pdfData);
    const fileURL = URL.createObjectURL(reportPDF);
    window.open(fileURL, '_blank');
    if (pdfData.referenceID) {
      reportService.createDownloadAuditLog(
        pdfData.caseManagerReferenceId,
        `${pdfData.title}.pdf`,
      );
    }
  };
  const handleGenerateDocx = () => {
    generateReportDocx(pdfData);
    if (pdfData.referenceID) {
      reportService.createDownloadAuditLog(
        pdfData.caseManagerReferenceId,
        `${pdfData.title}.docx`,
      );
    }
  };
  return (
    <>
      <Button
        disabled={!roles.is_allowed_to_download_final_report}
        variant='contained'
        color='lightGray'
        sx={{
          textTransform: 'none',
          color: '#878787',
        }}
        disableElevation
        startIcon={<img src={DownloadButtonIcon} alt='' />}
        onClick={handleClickDownloadButton}
      >
        <FormattedMessage defaultMessage='Final Report' />
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleCloseDownloadMenu}
        slotProps={{
          paper: {
            sx: {
              minWidth: 135,
              borderRadius: '6px',
              marginTop: '6px',
            },
          },
        }}
      >
        <MenuItem onClick={handleGenerateDocx}>
          <FormattedMessage defaultMessage='Word' />
        </MenuItem>
        <MenuItem onClick={generateFinalReport}>
          <FormattedMessage defaultMessage='PDF' />
        </MenuItem>
      </Menu>
    </>
  );
};

export default DownloadFinalReportButton;
